import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'login',
			meta: {
				title: "登录验证中",
				keepAlive: false
			},
			component: resolve => require(['../pages/Login.vue'], resolve)
		},
		{
			path:'/loginFree',
			name:'loginFree',
			meta:{
				title:'星巴克在线代点餐',
				keepAlive:false
			},
			component:resolve=>require(['../pages/NoPassHome.vue'],resolve)
		},
		{
			path: '/index',
			name: 'index',
			meta: {
				title: "登陆",
				keepAlive: false
			},
			component: resolve => require(['../pages/Index.vue'], resolve)
		},
		{
			path: '/payOrderDetail',
			name: 'payOrderDetail',
			meta: {
				title: "订单支付",
				keepAlive: false
			},
			component: resolve => require(['../pages/PayOrderDetail.vue'], resolve)
		},
		{
			path: '/OrderPay',
			name: 'OrderPay',
			meta: {
				title: "订单支付",
				keepAlive: false
			},
			component: resolve => require(['../pages/OrderPay.vue'], resolve)
		},
		{
			path: '/unSell',
			name: 'unSell',
			meta: {
				title: "星巴克在线代点餐",
				keepAlive: false
			},
			component: resolve => require(['../pages/UnSell.vue'], resolve)
		},
		{
			path: '/home',
			name: 'home',
			meta: {
				title: "星巴克在线代点餐",
				keepAlive: false
			},
			component: resolve => require(['../pages/Home.vue'], resolve)
		},
		{
			path: '/searchShop',
			name: 'searchShop',
			meta: {
				title: "星巴克在线代点餐",
				keepAlive: false
			},
			component: resolve => require(['../pages/SearchShop.vue'], resolve)
		},
		{
			path: '/location',
			name: 'location',
			meta: {
				title: "选择城市",
				keepAlive: false
			},
			component: resolve => require(['../pages/Location.vue'], resolve)
		},
		{
			path: '/service',
			name: 'service',
			meta: {
				title: "在线客服",
				keepAlive: false
			},
			component: resolve => require(['../pages/Service.vue'], resolve)
		},
		{
			path: '/orderHint',
			name: 'orderHint',
			meta: {
				title: "中杯通兑券",
				keepAlive: false
			},
			component: resolve => require(['../pages/OrderHint.vue'], resolve)
		},
		{
			path: '/coupon',
			name: 'coupon',
			meta: {
				title: "我的优惠券",
				keepAlive: false
			},
			component: resolve => require(['../pages/Coupon.vue'], resolve)
		},
		{
			path: '/goods',
			name: 'goods',
			meta: {
				title: "星巴克在线代点餐",
				keepAlive: false
			},
			component: resolve => require(['../pages/Goods.vue'], resolve)
		},
		{
			path: '/pay',
			name: 'pay',
			meta: {
				title: "星巴克在线代点餐",
				keepAlive: false
			},
			component: resolve => require(['../pages/Pay.vue'], resolve)
		},
		{
			path: '/payBack',
			name: 'payBack',
			meta: {
				title: "支付查询",
				keepAlive: false
			},
			component: resolve => require(['../pages/PayBack.vue'], resolve)
		},
		{
			path: '/orderDetail',
			name: 'orderDetail',
			meta: {
				title: "订单详情",
				keepAlive: false
			},
			component: resolve => require(['../pages/OrderDetail.vue'], resolve)
		},
		{
			path: '/recharge',
			name: 'recharge',
			meta: {
				title: "星巴克在线代点餐",
				keepAlive: false
			},
			component: resolve => require(['../pages/Recharge.vue'], resolve)
		},
		{
			path: '/userInfo',
			name: 'userInfo',
			meta: {
				title: "星巴克在线代点餐",
				keepAlive: false
			},
			component: resolve => require(['../pages/UserInfo.vue'], resolve)
		},

		{
			path: '/historyOrder',
			name: 'historyOrder',
			meta: {
				title: "我的订单",
				keepAlive: false
			},
			component: resolve => require(['../pages/HistoryOrder.vue'], resolve)
		},
		{
			path: '/city',
			name: 'city',
			meta: {
				title: "选择城市",
				keepAlive: false
			},
			component: resolve => require(['../pages/City.vue'], resolve)
		}
	]
})
